import Chip from '@mui/material/Chip';
import styled from '@mui/material/styles/styled';

import Text from '../../elements/text/Text';

export const StyledCreatorText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.dark,
  },
}));

export const StyledInstanceCreateDateText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const StyledProjectChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.grey[600],
  borderColor: theme.palette.grey[400],
  fontSize: theme.typography.caption.fontSize,
  marginLeft: theme.spacing(1),
}));

export const StyledSolrNodeChip = styled(Chip)(({ theme }) => ({
  color: 'white',
  fontWeight: 'bold',
  backgroundColor: theme.palette.primary.main,
  marginLeft: theme.spacing(2),
}));
